import { useRef } from "react";
import useRefSetter from "./useRefSetter";

export default function useRefWithSetter<T>(initValue: T) {
  const ref = useRef(initValue);
  const setter = useRefSetter(ref)

  return [ref, setter] as [typeof ref, typeof setter]
}
